import { useState, useEffect, useCallback, Fragment } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Button, CircularProgress, Grid, Typography, Tab, TableHead, Tabs, TableCell, Box, Table, TableBody, TableContainer, TableRow } from '@mui/material';
import { Tooltip } from 'style-guide';
import { styled } from '@mui/system';
import { REQUEST_ACTIONS, sendRequest, send_data_get } from 'utils/Communicator';
import './Manifest.scss';
import { useDispatch, useSelector } from 'react-redux';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import { onSelectedLocationIndexChange, onUserAbroadIdChange, onSelectedTabIndexNameChange } from 'reducers/parcel-reducers/orderTableFilterSlicer';
import { onWarehouseChange, resetManifestSlice } from 'reducers/parcel-reducers/manifestsSlicer';
import { getOrders, onPageChange } from 'reducers/parcel-reducers/ordersSlicer';
import { Dialog } from 'style-guide';
const tableTh1 = [
    { id: 1, name: 'Create Date' },
    { id: 15, name: 'HAWB' },
    /* { id: 2, name: 'Locker Id' },*/
    /*{ id: 13, name: 'Validate' },*/
    /*{ id: 5, name: 'Receiver Name' },*/
    { id: 7, name: 'Sender' },
    { id: 3, name: 'Weight' },
    /*{ id: 4, name: 'Order Number' },*/
    /* { id: 6, name: 'Warehouse Status' },
     { id: 10, name: 'Status' },
     { id: 7, name: 'Sender' },*/
    { id: 8, name: 'Location' },
    { id: 10, name: 'Status' },
    { id: 16, name: 'Damaged' }
    /*{ id: 9, name: 'Add/Remove' },*/
    /* { id: 14, name: 'Extra Details' },
     { id: 11, name: 'Last Update' },
     { id: 12, name: '' },*/
]
const ManifestHistory = ({ loginUser }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const tur_csv_m = { "TS S?ra No": "1", "Kargo Manifesto No": "", "Ta??ma Senedi No": "", "S?ra No": "", "Kalem No": "", "G�nderen": "", "G�nderen �nvan": "Total Care Lojistik Hizmetleri Anonim Sirketi", "G�nderen VN": "8580967328", "Al?c?": "", "Al?c? �nvan": "", "Al?c? VN": "", "Al?c? Adres": "", "Al?c? il Kodu": "", "Al?c? ?l�e": "", "Al?c? Posta Kodu": "", "M�?avir Ad?": "MERVE OKTAY", "M?vr. Vergi No": "", "Sevk �lkesi": "052", "�lke Ad?": "T�RK?YE", "Ticaret �lke": "052", "�lke Ad? 1": "T�RK?YE", "�?k?? �lkesi": "052", "�lke Ad? 2": "T�RK?YE", "Men?e �lke": "052", "�lke Ad? 3": "T�RK?YE", "Gidece?i �lke": "624", "�lke Ad? 4": "?SRA?L", "Teslim ?ekli": "FOB", "Teslim Yeri": "", "??lem Niteli?i": "", "Kap Adedi": "", "Kap Cinsi": "ADET", "Konteyner No": "", "Konteyner Marka": "", "Konteyner Tipi": "", "Ticari Tan?m": "", "Kullan?lm?? E?ya Kodu": "", "GTip": "", "Muafiyet Kodu": "", "Muafiyet 2": "", "Muafiyet 3": "", "Tercihli Tarife": "", "Brut KG": "", "Net KG": "", "Rejim": "", "Kota": "", "Tamamlay?c? �l��": "ADET", "Tamamlay?c? �l�� Miktar?": "", "Fat. Doviz": "TL", "Fatura": "", "Fatura EUR": "", "Fatura Kuru": "", "Fatura No": "", "Fatura Tarihi": "", "Hesaplama Y�n": "", "?statiski K?y.": "Mal ?hracat?", "Navlun": "", "Navlun Doviz": "USD", "Sigorta": "", "Sig. Doviz": "", "Yurt D??? Harcama": "", "YD. Doviz": "", "Yurt ?�i Harcama": "", "K?rm?z? Hat": "", "Ayr?lan Kalem": "", "Teslim Tarihi": "", "Hacim": "", "Gelen Brut KG": "", "Gelen Net KG": "", "Gelen Kap Adedi": "", "Tamamlay?c? Beyan Hata": "", "Kayd? A�an": "SGOZPINAR", "??le S?ra No": "", "Mail G�nderim": "", "?? Emri Olu?tur": "", "ATR No": "", "ATR Tarihi": "", "Men?e Belge No": "", "Men?e Belge Tarihi": "", "EUR-1 No": "", "EUR-1 Tarihi": "", "EUR.MED No": "", "EUR.MED Tarihi": "", "FormA No": "", "FormA Tarihi": "", "Bandrol": "", "KuryeMail": "", "�nvan De?i?ikli?i Tutar ": "", "�nceki Beyanname No": "", "�nceki Beyanname Tarihi": "", "�nceki Ta??ma Senedi No": "", "Notlar": "M?KRO ?HRACAT", "Notlar II": "", "Notlar III": "", "KalemDV": "" }
    const tur_csv_m_header = ["TS S?ra No", "Kargo Manifesto No", "Ta??ma Senedi No", "S?ra No", "Kalem No", "G�nderen", "G�nderen �nvan", "G�nderen VN", "Al?c?", "Al?c? �nvan", "Al?c? VN", "Al?c? Adres", "Al?c? il Kodu", "Al?c? ?l�e", "Al?c? Posta Kodu", "M�?avir Ad?", "M?vr. Vergi No", "Sevk �lkesi", "�lke Ad?", "Ticaret �lke", "�lke Ad? 1", "�?k?? �lkesi", "�lke Ad? 2", "Men?e �lke", "�lke Ad? 3", "Gidece?i �lke", "�lke Ad? 4", "Teslim ?ekli", "Teslim Yeri", "??lem Niteli?i", "Kap Adedi", "Kap Cinsi", "Konteyner No", "Konteyner Marka", "Konteyner Tipi", "Ticari Tan?m", "Kullan?lm?? E?ya Kodu", "GTip", "Muafiyet Kodu", "Muafiyet 2", "Muafiyet 3", "Tercihli Tarife", "Brut KG", "Net KG", "Rejim", "Kota", "Tamamlay?c? �l��", "Tamamlay?c? �l�� Miktar?", "Fat. Doviz", "Fatura", "Fatura EUR", "Fatura Kuru", "Fatura No", "Fatura Tarihi", "Hesaplama Y�n", "?statiski K?y.", "Navlun", "Navlun Doviz", "Sigorta", "Sig. Doviz", "Yurt D??? Harcama", "YD. Doviz", "Yurt ?�i Harcama", "K?rm?z? Hat", "Ayr?lan Kalem", "Teslim Tarihi", "Hacim", "Gelen Brut KG", "Gelen Net KG", "Gelen Kap Adedi", "Tamamlay?c? Beyan Hata", "Kayd? A�an", "??le S?ra No", "Mail G�nderim", "?? Emri Olu?tur", "ATR No", "ATR Tarihi", "Men?e Belge No", "Men?e Belge Tarihi", "EUR-1 No", "EUR-1 Tarihi", "EUR.MED No", "EUR.MED Tarihi", "FormA No", "FormA Tarihi", "Bandrol", "KuryeMail", "�nvan De?i?ikli?i Tutar ", "�nceki Beyanname No", "�nceki Beyanname Tarihi", "�nceki Ta??ma Senedi No", "Notlar", "Notlar II", "Notlar III", "KalemDV"]
    const { selectedLocationIndex, selectedTabIndexName} = useSelector(state => state.parcelTableFilter);
    const [manifestAdmin, setManifestAdmin] = useState({});
    const [manifestList, setManifestList] = useState([]);
    const { warehouse } = useSelector(state => state.manifests);
    const onHandleSelectedLocationIndexChange = (event, newValue) => {
        dispatch(onUserAbroadIdChange(null));
        dispatch(onSelectedLocationIndexChange(newValue));
    }
    const [openOrderModalSureExport, setOpenOrderModalSureExport] = useState(false);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleCancelModal = () => setOpenOrderModal(false);
    const [manifestSelected, setManifestSelected] = useState(false);
    const onHandleOpenModalSureExport = (manifestSelected1) => {
        setOpenOrderModalSureExport(true);
        setManifestSelected(manifestSelected1);
    };

    const onHandleCancelModalSureExport = () => setOpenOrderModalSureExport(false);

    const onSearch = () => {
        setIsLoaded(false);
        sendRequest('/api/parcel/getAgentManifestListByWarehouse', REQUEST_ACTIONS.POST, { "wareHouseId": selectedLocationIndex == 1 ? 14 : 13 }, {
            successCallback: response => {
                setIsLoaded(true);
                const dropStatus = (selectedTabIndexName == 'Drops' || selectedTabIndexName == 'DropsHistory');
                setManifestList(response?.data?.filter(manifest => (manifest?.params?.dropStatus == dropStatus || (!dropStatus && manifest?.params?.dropStatus == null)))?.sort(function (a, b) {
                return new Date(b?.updateDate) - new Date(a?.updateDate);
            }));
            },
            failedCallback,
        });
        sendRequest('/api/parcel/getAdminByAdminId', REQUEST_ACTIONS.POST, { "id": selectedLocationIndex == 1 ? 22 : 23 }, {
            successCallback: response => {
                setIsLoaded(true);
                setManifestAdmin(response)
            },
            failedCallback,
        });
        sendRequest('/api/parcel/getWareHouseById', REQUEST_ACTIONS.POST, { "wareHouseId": selectedLocationIndex == 1 ? 14 : 13 }, {
            successCallback: response => {
                dispatch(onWarehouseChange(response));
            },
            failedCallback,
        });

    }
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);


    useEffect(() => {
        dispatch(resetManifestSlice(null));
        onSearch();
    }, [
        selectedLocationIndex,
        dispatch,
        failedCallback,
    ]);



    const [isLoaded, setIsLoaded] = useState(true);

    useEffect(() => {
        if (location?.state?.name == "location") {
            dispatch(onSelectedLocationIndexChange(location?.state.locInd));
        }
    }, []);

    function formatDate(date) {
        let p = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            //second: '2-digit',
            hour12: false,
            timeZone: 'UTC',
            //timeZoneName: "longOffset",
        }).format(date)
        return p
        /*formatToParts(date).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
    }, {});*/

        return `${p.day}/${p.month}/${p.year}, ${p.hour}:${p.minute}:${p.second} ${p.dayPeriod} `;
    }
    const [selectedMani, setSelectedMani] = useState({});
    const [selectedParcels, setSelectedParcels] = useState([]);
    const [openOrderModalManiInfo, setOpenOrderModalManiInfo] = useState(false);
    const onHandleOpenModalManiInfo = (data) => {
        setSelectedMani(data);

        const request = { "ids": data?.params?.reqForStart.join(',').toString() };
        sendRequest('/api/parcel/getAgentRequestListByIds', REQUEST_ACTIONS.POST, request, {
            successCallback: response => {
                setSelectedParcels(response.data);
                setOpenOrderModalManiInfo(true);
            },
            failedCallback,
        });

        //getAdminList(dispatch, admin);
        //getWarehouseList(dispatch, admin);
    };
    const onHandleCancelModalManiInfo = () => setOpenOrderModalManiInfo(false);
    const getChargableWt = (list) => {
        var tChW = 0
        for (var i = 0; i < list.length; i++) {
            var weight = list[i].params?.userPaymentData.weight;
            var h = list[i].params?.userPaymentData.height;
            var w = list[i].params?.userPaymentData.width;
            var l = list[i].params?.userPaymentData['length'];
            var wt = Number(l) * Number(w) * Number(h) / 5000;
            var chWt = Number(wt) > Number(weight) ? Number(wt) : Number(weight);
            tChW = tChW + chWt;
        }
        return tChW
    }
    const getChargableWtItem = (list) => {
        var weight = list.params?.userPaymentData.weight;
        var h = list.params?.userPaymentData.height;
        var w = list.params?.userPaymentData.width;
        var l = list.params?.userPaymentData['length'];
        var wt = Number(l) * Number(w) * Number(h) / 5000;
        var chWt = Number(wt) > Number(weight) ? Number(wt) : Number(weight);
        return chWt
    }

    function exportTR_CSV(data, name) {
        var manifestItems = data.manifestItems;
        console.log(data.params)
        const request = { "ids": data?.params?.reqForStart.join(',').toString() };
        sendRequest('/api/parcel/getAgentRequestListByIds', REQUEST_ACTIONS.POST, request, {
            successCallback: response => {
                const list1 = response.data;
                console.log(list1)
                var items = []
                for (var j = 0; j < manifestItems.length; j++) {
                    console.log(manifestItems[j])
                    var sh = list1.find(u => u.hawb === manifestItems[j].ConsignmentNumber)
                    /*
                    'G�nderen �nvan': sh.params?.vParent?.vendorName,
                        'G�nderen VN': sh.params?.vParent?.vendorTax,
                    */
                    if (data.adminId != 11) {
                        var t = {
                            ...tur_csv_m,
                            'Kargo Manifesto No': manifestItems[j]?.MAWB,
                            'Ta??ma Senedi No': manifestItems[j]?.HAWB,
                            'G�nderen �nvan': sh.params?.sender?.senderName,
                            'G�nderen VN': sh.params?.sender?.senderVat,
                            'Al?c? �nvan': manifestItems[j]?.ReceiverName,
                            'Al?c? Adres': manifestItems[j]?.ReceiverStreetAddress,
                            'Kap Adedi': manifestItems[j]?.Quantity,
                            'Ticari Tan?m': sh.params?.pName,
                            'GTip': "",
                            'Brut KG': manifestItems[j]?.Weight,
                            'Net KG': sh.params?.netWeight,
                            'Fat. Doviz': manifestItems[j]?.InvoiceCurrency,
                            'Fatura': sh.params?.TRANZILLA_RECIEPT?.document?.total_charge_amount ? sh.params?.TRANZILLA_RECIEPT?.document?.total_charge_amount : manifestItems[j]?.InvoiceLineAmount,
                            'Fatura No': manifestItems[j]['Receipt Number'],
                            'Fatura Tarihi': sh.params?.TRANZILLA_RECIEPT?.document?.created_at,
                            'Navlun': Number(sh.params?.transportVal_nis).toFixed(2),
                            'Navlun Doviz': manifestItems[j]['FreightCurrency'],
                            'Tamamlay?c? �l�� Miktar?': manifestItems[j]?.Quantity,
                            /*'Teslim ?ekli': manifestItems[j]?.ReceiverStreetAddress,*/

                        }
                        items.push(t);
                    } else {
                        for (var k = 0; k < sh?.params?.products.length; k++) {
                            var t = {
                                ...tur_csv_m,
                                'Kargo Manifesto No': manifestItems[j]?.MAWB,
                                'Ta??ma Senedi No': manifestItems[j]?.HAWB,
                                'G�nderen �nvan': sh.params?.vParent?.vendorName,
                                'G�nderen VN': sh.params?.vParent?.vendorTax,
                                'Al?c? �nvan': manifestItems[j]?.ReceiverName,
                                'Al?c? Adres': manifestItems[j]?.ReceiverStreetAddress,
                                'Kap Adedi': manifestItems[j]?.Quantity,
                                'Ticari Tan?m': sh?.params?.products[k].productName,
                                'GTip': "",
                                'Brut KG': sh?.params?.products[k].weight,
                                'Net KG': sh.params?.netWeight,
                                'Fat. Doviz': manifestItems[j]?.InvoiceCurrency,
                                'Fatura': sh.params?.TRANZILLA_RECIEPT?.document?.total_charge_amount ? sh.params?.TRANZILLA_RECIEPT?.document?.total_charge_amount : manifestItems[j]?.InvoiceLineAmount,
                                'Fatura No': manifestItems[j]['Receipt Number'],
                                'Fatura Tarihi': sh.params?.TRANZILLA_RECIEPT?.document?.created_at,
                                'Navlun': Number(sh.params?.transportVal_nis).toFixed(2),
                                'Navlun Doviz': manifestItems[j]['FreightCurrency'],
                                'Tamamlay?c? �l�� Miktar?': sh?.params?.products[k].packages,
                                /*'Teslim ?ekli': manifestItems[j]?.ReceiverStreetAddress,*/

                            }
                            items.push(t);
                        }

                    }

                }
                exportCSVFile(tur_csv_m_header, items, name);
            },
            failedCallback,
        });
    }

    const exportToCsv = function (data, name, dispatch, admin) {
        var manifestItems = data.manifestItems;
        var recieptList = data.params.recieptList;


        /*for (var i = 0; i < recieptList.length; i++) {
            downLoadPdf(recieptList[i].reciept, recieptList[i].name);
        }*/
        //var headers = Object.keys(manifestItems[0])
        var headers = ["Sender",
            "SenderAddress",
            "SenderCountry",
            "ReceiverName",
            "ReceiverStreetAddress",
            "ReceiverZipcode",
            "ReceiverCity",
            "ReceiverCountry",
            "ReceiverPhone",
            "ReceiverEmail",
            "ReceiverReceiverId",
            "ConsignmentNumber",
            "Reference1",
            "Reference2",
            "GoodsDesc",
            "Cubic",
            "Weight ",
            "ChargeWeight",
            "Quantity",
            "DeliveryInstructions",
            "InvoiceValue",
            "InvoiceCurrency",
            "InvoiceLineQty",
            "InvoiceLineAmount",
            "OriginPort",
            "GatewayPort",
            "AgentCode",
            "CarrierPrefix",
            "MAWB",
            "HAWB",
            "FlightDate",
            "FlightTime",
            "FlightNumber",
            "ETADate",
            "SendeETATimer",
            "TotalMasterQuantity",
            "TotalMasterWeightKgm",
            "InvoiceLineOriginCountry",
            "IsAutonomy",
            "CourierAWBDate",
            "ReceiverPassportId",
            "ReceiverPassportCountry",
            "FreightTotalAmount",
            "FreightCurrency",
            "DeliveryMethod",
            "TotalPackageInMawb",
            "TotalShipment",
            "CrateNumber",
            "StorageSiteCode",
            "empty1",
            "empty2",
            "Amount to be Charge In Nis",
            "Amount to be Charge In Nis1",
            "Amount to be Charge In Nis2",
            "Amount to be Charge In Nis3",
            "Amount to be Charge In Nis4",
            "Receipt Number",
        ]
        exportCSVFile(headers, manifestItems, name);
        for (var i = 0; i < manifestItems.length; i++) {
            sleep(1000)
            //console.table(manifestItems[i].ConsignmentNumber)
            recieptWithBarCode(manifestItems[i].ConsignmentNumber)
        }
        for (var i = 0; i < manifestItems.length; i++) {
            sleep(1000)
            //console.table(manifestItems[i].ConsignmentNumber)
            recieptUserUploaded(manifestItems[i].ConsignmentNumber)
        }
    }

    const sleep = (ms) => {
        return new Promise((resolve, reject) => setTimeout(resolve, ms));
    };

    const manifestInvoice = (id, mawb) => {
        var url = "/shipping/manifestInvoice/1/" + id;
        send_data_get("/api/parcel/invokeDownloadService?endpoint=" + url, "Invoice_" + mawb);
    }

    function exportCSVFile(headers, items, fileTitle) {

        var csv = convertToCSV1(items, headers);

        var exportedFilenmae = fileTitle;
        var universalBOM = "\uFEFF";
        csv = universalBOM + csv
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                try {
                    var url = window.URL.createObjectURL(blob);

                    link.setAttribute("href", (url));
                    link.setAttribute("download", exportedFilenmae);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (err) {
                    if (err.message) {
                        //console.table(err.message)
                    }
                    //console.table(err)
                }

            }
        }
    }

    const recieptWithBarCode = (hawb) => {
        var url = "/shipping/recieptWithBarCode/1/" + hawb;
        send_data_get("/api/parcel/invokeDownloadService?endpoint=" + url, "CWB_" + hawb);
    }

    const recieptUserUploaded = (hawb) => {
        var url = "/shipping/recieptUserUploaded/1/" + hawb;
        send_data_get("/api/parcel/invokeDownloadService?endpoint=" + url, "HWB_" + hawb);
    }

    function convertToCSV1(items, header1) {
        const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
        const header = header1
        let BOM = [0xEF, 0xBB, 0xBF]
        let csv = [
            header.join(','), // header row first
            ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        ].join('\r\n')
        console.log(csv)
        return csv;
    }

    return (
        <Grid container>
            {openOrderModalSureExport && (
                <Dialog maxWidth='sm' open={onHandleCancelModalSureExport} title={`Confirm`} onHandleCancel={onHandleCancelModalSureExport}>

                    <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                        Downloading Manifest's files Are you sure ?
                    </Grid>
                    <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#d70007", padding: "3px" }} onClick={() => {
                        exportToCsv(manifestSelected, "Manifest.csv", dispatch, '')
                        onHandleCancelModalSureExport();
                    }}>Yes</Button>
                    <Button sx={{ m: 2, borderRadius: "25px", background: "#d70007", padding: "3px" }} variant='contained' onClick={onHandleCancelModal}>No</Button>
                </Dialog>
            )}
            {!isLoaded ? (
                <Grid container item justifyContent='center' mt={8}>
                    <CircularProgress />
                </Grid>
            ) : (
                <Fragment>
                    <Grid container rowSpacing={1}>
                        {!(loginUser?.authorities && loginUser?.authorities[0]?.authority === 'User' && (loginUser?.location?.code === 'NL' || loginUser?.location?.code === 'US')) ?
                            (
                                <Grid item xs={12}>
                                    <Tabs value={selectedLocationIndex} onChange={onHandleSelectedLocationIndexChange} sx={{ minHeight: "30px", overflow: "hidden", border: "1px solid #ccc", backgroundColor: "#f1f1f10a" }}>
                                        <StyledTab label="NL" className="locationTab" />
                                        <StyledTab label="US" className="locationTab" />
                                        <StyledTab label="IL" className="locationTab" />
                                    </Tabs>
                                </Grid>) : null}
                        <Grid container item xs={9.4} spacing={1} style={{ marginTop: '0px'}}>
                            {/* <Typography noWrap variant='h5'>Orders History</Typography>*/}
                                <Button color='secondary' variant='contained' sx={{ fontWeight: "400", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                dispatch(onSelectedTabIndexNameChange("Orders"));
                                dispatch(getOrders([]));
                                dispatch(onPageChange(0));
                                window.setTimeout(function () {
                                    navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
                                }, 500)
                                //agentOrders()
                            }}>
                                Orders
                            </Button>
                                <Button color='secondary' variant='contained' sx={{ fontWeight: "400", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "16%", fontSize: "1vw !important" }} onClick={() => {
                                dispatch(onSelectedTabIndexNameChange("OrdersHistory"));
                                dispatch(getOrders([]));
                                // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                dispatch(onPageChange(0));
                                window.setTimeout(function () {
                                    navigate("/orderHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "ordersHistory" } })
                                }, 500)
                            }}>
                                Order History
                            </Button>
                                <Button color='secondary' variant='contained' sx={{ fontWeight: "400", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                dispatch(onSelectedTabIndexNameChange("Parcels"));
                                dispatch(getOrders([]));
                                dispatch(onPageChange(0));
                                window.setTimeout(function () {
                                    navigate("/phome", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Parcels" } })
                                }, 500)
                                //redboxParcels()
                            }}>
                                Redbox
                            </Button>
                                <Button color='secondary' variant='contained' sx={{ fontWeight: "400", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "17%", fontSize: "1vw !important" }} onClick={() => {
                                dispatch(onSelectedTabIndexNameChange("ParcelsHistory"));
                                dispatch(getOrders([]));
                                // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                dispatch(onPageChange(0));
                                window.setTimeout(function () {
                                    navigate("/parcelHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "ParcelsHistory" } })
                                }, 500)
                                //redboxParcels()
                            }}>
                                Redbox History
                            </Button>
                                <Button color='secondary' variant='contained' sx={{ fontWeight: "400", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                dispatch(onSelectedTabIndexNameChange("Drops"));
                                dispatch(getOrders([]));
                                dispatch(onPageChange(0));
                                window.setTimeout(function () {
                                    navigate("/dhome", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Drops" } })
                                }, 500)
                                //redboxParcels()
                            }}>
                                Drop
                            </Button>
                                <Button color='secondary' variant='contained' sx={{ fontWeight: "400", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "17%", fontSize: "1vw !important" }} onClick={() => {
                                dispatch(onSelectedTabIndexNameChange("DropsHistory"));
                                dispatch(getOrders([]));
                                // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                dispatch(onPageChange(0));
                                window.setTimeout(function () {
                                    navigate("/dropHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "DropsHistory" } })
                                }, 500)
                                //redboxParcels()
                            }}>
                                Drop History
                            </Button>
                        </Grid>
                    </Grid>

                    {manifestList.length > 0 && <TableContainer sx={{ height: "calc(100vh - 145px)", marginTop: '15px', width: '100%', overflow: 'hidden', boxShadow: 'rgb(0 0 0) 0px 2px 1px -1px, rgb(0 0 0) 0px 1px 1px 0px, rgb(0 0 0) 0px 1px 3px 0px' }}>
                        {openOrderModalManiInfo && (
                            <Dialog fullWidth={false} sx={{ minWidth: "90vw" }} open={openOrderModalManiInfo} title={`${formatDate(new Date(selectedMani?.updateDate))}| Num Parcels: ${selectedParcels?.length || 0} |Total Weight: ${getChargableWt(selectedParcels)} KG`} onHandleCancel={onHandleCancelModalManiInfo}>
                                <Grid container sx={{ justifyContent: "space-between" }} className="box-container">

                                    <TableContainer>
                                        <Table className='parcel-table' stickyHeader aria-label="sticky table">
                                            <TableHead style={{ borderBottom: '1px solid #ccc' }}>
                                                <TableRow>
                                                    {tableTh1.map((th) => <TableCell key={th.id}> {th.name} </TableCell>)}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedParcels?.map((data) => <TableRow key={data.id}>

                                                    <TableCell> {formatDate(new Date(data.create_date))}</TableCell>
                                                    <TableCell> {data?.hawb} </TableCell>


                                                    {/*<TableCell> {users.find(u => u.id === data.userId)?.lastName} {users.find(u => u.id === data.userId)?.firstName} </TableCell>*/}
                                                    <TableCell> {data?.params?.sender?.senderName || '-'} <Box className="text-12 ">{data.params.majorCategory} </Box></TableCell>
                                                    <TableCell> {getChargableWtItem(data)} kg</TableCell>

                                                    <TableCell> {data.params?.storageLocation} </TableCell>
                                                    <TableCell>{data.params && data.params?.shippingStatus ? data.params.shippingStatus.StatusText : '-'}</TableCell>
                                                    <TableCell>
                                                        <Grid className='flex-row'>
                                                            {data.params?.damaged && <div fill="red" title="Damaged" style={{ width: '30px', height: "20px", borderRadius: "25px" }} />}
                                                        </Grid>
                                                    </TableCell>

                                                </TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Dialog>
                        )}
                        <Table className='parcel-table'>
                            <TableHead style={{ borderBottom: '1px solid #ccc' }}>
                                <TableRow>
                                    <TableCell >

                                        Update Date

                                    </TableCell>
                                    <TableCell >

                                        Users

                                    </TableCell>
                                    <TableCell >

                                        Warehouse

                                    </TableCell>
                                    <TableCell >

                                        HAWB

                                    </TableCell>
                                    <TableCell >

                                        MAWB

                                    </TableCell>
                                    <TableCell >

                                        FTP Update

                                    </TableCell>
                                    <TableCell >

                                        Action

                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {manifestList.length > 0 &&
                                    manifestList?.map(manifest => (
                                        <TableRow style={{ background: manifest.params?.ftpExported ? "#9acc9a" : '' }} key={manifest.id} >
                                            <TableCell onClick={() => { onHandleOpenModalManiInfo(manifest) }}>

                                                {formatDate(new Date(manifest.updateDate))}

                                            </TableCell>
                                            <TableCell onClick={() => { onHandleOpenModalManiInfo(manifest) }}>

                                                {manifestAdmin?.adminName || '-'}

                                            </TableCell>
                                            <TableCell onClick={() => { onHandleOpenModalManiInfo(manifest) }}>

                                                {warehouse?.name || '-'}

                                            </TableCell>
                                            <TableCell onClick={() => { onHandleOpenModalManiInfo(manifest) }}>

                                                {manifest.params?.MHWB}

                                            </TableCell>
                                            <TableCell onClick={() => { onHandleOpenModalManiInfo(manifest) }}>

                                                {manifest.mawb}

                                            </TableCell>
                                            <TableCell style={{ minWidth: "10vw" }} onClick={() => { onHandleOpenModalManiInfo(manifest) }}>

                                                {!manifest.params?.ftpExported ? 'FTP not exported' : 'FTP exported at ' + formatDate(new Date(manifest.params?.ftpExport_time)) + " by " + manifest.params?.ftpExportBy}

                                            </TableCell>

                                            <TableCell style={{ maxWidth: "15vw" }}>
                                                <Tooltip title='Downloading files for check'>
                                                    <Button variant='outlined' sx={{ mr: 1, background: '#fff' }} size="small" onClick={event => { onHandleOpenModalSureExport(manifest) }}>
                                                        Export
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title='Export Declaration from Origin'>
                                                    <Button variant='outlined' sx={{ mr: 1, background: '#fff' }} size="small" onClick={event => { manifestInvoice(manifest.id, manifest.mawb) }}>
                                                        ED {(loginUser.location.code === 'US' || selectedLocationIndex == 1) ? 'US' : 'NL'}
                                                    </Button>
                                                </Tooltip>
                                                { /*<Button  variant='outlined' sx={{ mr: 1 }} size="small" onClick={() => {exportTR_CSV(manifest, "Manifest_TR.csv")}}>
                                                    ED TK
                                                </Button> */}

                                            </TableCell>

                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    }
                </Fragment>
            )}
        </Grid>
    );
};

export default ManifestHistory;

export const StyledTab = styled(Tab)({
    border: '1px solid black',
    'font-size': '17px',
    'margin-right': '2px',
    'padding': '14px 16px',
    'min-height': '30px',
});
